import React, { useContext, useEffect, useState } from 'react';
import usersService from 'services/http/users-service';
import jwtWorker from 'utils/jwt-worker';
import { DropdownTemplate } from "components/shared"
import utils, { AGENT_STATUS } from 'utils';
import { MasterPageContext } from 'components/pages';

export const AgentStatus = () => {

    const [statusItems, setStatusItems] = useState({ data: [], error: null });
    const [currentStatus, setCurentStatus] = useState({ data: null, error: null });
    const [loading, setLoading] = useState(false);
    const [selectedStatus, setSelectedSatus] = useState();
    const [refreshStatus, setRefreshStatus] = useState(true);
    const masterContext = useContext(MasterPageContext);

    useEffect(() => {
        if (refreshStatus) {
            setLoading(true);
            usersService.getAllStatus().then((response) => {
                Promise.resolve(onFetchingStatusItems(response)).then((items) => {
                    getCurrentStatus(items);
                });
            }, error => {
                setStatusItems({ ...statusItems, error: error });
                setLoading(false);
            }).finally(() => {
                setRefreshStatus(false);
            });
        }
    }, [refreshStatus]);

    //ON SUCCESS FETCHING STATUS ITEMS
    const onFetchingStatusItems = (response) => {
        setStatusItems({ ...statusItems, data: utils.bindAgentStatusOptions(response.result), error: null });
        return utils.bindAgentStatusOptions(response.result);
    }

    //FETCHING CURRENT USER STATUS
    const getCurrentStatus = (items) => {
        usersService.getCurrentStatus(jwtWorker.getSubFromToken()).then((response) => {
            setCurentStatus({ ...currentStatus, data: response.result, error: null });
            let current = items.find((item) => {
                return item.id === response.result.statusUserId;
            });
            setSelectedSatus(current?.value);
        }, error => {
            setCurentStatus({ ...currentStatus, error: error });
        }).finally(() => {
            setLoading(false);
        });
    }

    //UPDATE CURRENT USER STATUS
    const updateCurrentStatus = (e) => {
        usersService.updateLastStatus(jwtWorker.getSubFromToken(), getStatusId(e.value)).then((resp) => {
            setSelectedSatus(e.value);
            dispatchCurrentStatus(getStatusId(e.value));
        }, error => {
            setCurentStatus({ ...currentStatus, error: error });
        });
    }

    //GET STATUS ID FROM ITEMS BASED ON DESCRIPTION FIELD
    const getStatusId = (description) => {
        return statusItems.data.find((item) => {
            return item.value === description
        }).id;
    }

    //DISPATCH THROUGH STATUS
    const dispatchCurrentStatus = (statusId) => {
        masterContext.setRefreshTaskSideBasedStatus(
            statusId === AGENT_STATUS[0].STATUS_ID ||
            statusId === AGENT_STATUS[1].STATUS_ID ||
            statusId === AGENT_STATUS[2].STATUS_ID
        );
    }

    const UnkownStatustemplate = () => {
        return <div className="my-2"><small> <i className="bi bi-circle" /> </small>unkown status</div>
    }
    const ErrorTemplate = (props) => {
        return <div className="text-danger my-2">
            <small>
                <i className="bi bi-arrow-clockwise" style={{ cursor: 'pointer' }} onClick={() => setRefreshStatus(true)} /> {props.message}
            </small>
        </div>
    }

    return (
        <div>
            {
                loading ? <UnkownStatustemplate /> :
                    <>
                        {
                            (!statusItems.error && !currentStatus.error) ?
                                <DropdownTemplate
                                    placeholder="Agent status"
                                    options={statusItems.data}
                                    optionLabel={'value'}
                                    className="custom-dropdown-4-header custom-dropdown"
                                    onItemChange={updateCurrentStatus}
                                    selectedItem={selectedStatus}
                                /> :
                                <ErrorTemplate message={statusItems.error ? statusItems.error : currentStatus.error} />
                        }
                    </>
            }
        </div>
    );
}